
export default {
  name: 'StudentIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
